/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appGitlab_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly gitlabEnabled: boolean | null;
        readonly gitlabServerEnabled: boolean | null;
        readonly gitlabServerUrl: string | null;
        readonly gitlabServerToken: string | null;
        readonly gitlabDeleteIssues: boolean | null;
    } | null;
    readonly " $refType": "appGitlab_viewer";
};
export type appGitlab_viewer$data = appGitlab_viewer;
export type appGitlab_viewer$key = {
    readonly " $data"?: appGitlab_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appGitlab_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appGitlab_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gitlabEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gitlabServerEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gitlabServerUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gitlabServerToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gitlabDeleteIssues",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '63afd992d0c6b7a6c8a659e3a09db8bc';
export default node;
